<template>
  <div class="backStack-issue-wrap informationCreate">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
    >
    </From>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit(0)">保存</a-button>
        <a-button class="submit-audit" @click="toAudit(1)">保存并发布</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/mixins/backStack'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import { formRules, formRows } from './configs/formOptions.js'
import { queryTeamInfos, teamUpdate } from '@/api/talentsInfo.js'

export default {
  mixins: [mixinsBackStack, mixinConfigSetting],
  data() {
    return {
      loading: true,
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {},
      isRead: false,
      detailId: null
    }
  },
  components: {
    From
  },
  created() {
    this.initSetting()
  },
  methods: {
    // 初始化数据
    initSetting() {
      const { id } = this.$route.query
      this.detailId = id
      this.initDefaultModel()
    },
    async initDefaultModel() {
      const { data } = await queryTeamInfos(this.detailId)
      const { fileVo, ...otherParam } = data
      this.defaultModel = {
        picPath: fileVo,
        ...otherParam
      }
      console.log(this.defaultModel)
      this.defaultModel.techPatents.forEach((item, key) => {
        item.key = key + 1
      })
    },
    async toAudit(status) {
      this.$refs.formRef.validatedForm(async () => {
        try {
          const { picPath, ...formValue } = this.$refs.formRef.formModel
          const pic = this.handlerPicPathIds(picPath).join(',')
          const params = {
            ...formValue,
            pic,
            status,
            id: this.detailId
          }
          const { msg, code } = await teamUpdate(params)
          this.$apiStatusHandler(code, msg)
          this.$router.push('/talents/techTeam')
        } catch (error) {
          console.log(error)
          this.$apiStatusHandler(99, error)
        }
      })
    },
    handlerPicPathIds(picPath) {
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        if (item.response) {
          const { fileId } = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.id)
        }
        return pre
      }, [])
    }
  }
}
</script>
